import { render, staticRenderFns } from "./RegisterConfirmation.vue?vue&type=template&id=1beda770&"
import script from "./RegisterConfirmation.vue?vue&type=script&lang=js&"
export * from "./RegisterConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports